import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import type { ShopCategoryMarket } from '@/types';
import { fetchAllCartDiscounts } from '@/utils/shopCategoryApi';
const PROMO_OFFER_NAME_OPTIONS_MS = 60 * 60 * 1000;
export const usePromoOfferNameOptions = (market, enabled) => {
  const $ = _c(14);
  let t0;
  let t1;
  if ($[0] !== market) {
    t0 = ["shopCategoryCartDiscounts", market];
    t1 = () => market ? fetchAllCartDiscounts(market) : Promise.resolve([]);
    $[0] = market;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = enabled && Boolean(market);
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      staleTime: PROMO_OFFER_NAME_OPTIONS_MS,
      queryKey: t0,
      queryFn: t1,
      enabled: t2,
      select: _temp3
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data: t4,
    isError: hasQueryError,
    isFetching,
    isSuccess,
    refetch
  } = useQuery(t3);
  let t5;
  if ($[7] !== t4) {
    t5 = t4 === undefined ? [] : t4;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const options = t5;
  const isEnabled = enabled && Boolean(market);
  const t6 = isEnabled && (hasQueryError || isSuccess && options.length === 0);
  const t7 = isEnabled && isFetching;
  let t8;
  if ($[9] !== options || $[10] !== refetch || $[11] !== t6 || $[12] !== t7) {
    t8 = {
      options,
      isError: t6,
      isLoading: t7,
      refetch
    };
    $[9] = options;
    $[10] = refetch;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
function _temp(discount) {
  return discount.key;
}
function _temp2(key) {
  return {
    label: key,
    value: key
  };
}
function _temp3(discounts) {
  return [...new Set((discounts ?? []).map(_temp).filter(Boolean))].map(_temp2);
}